// Access gate for the per-loan Chat tab (drilldown).
//
// The chat feature is new and being trialed. It's visible when EITHER:
//   • the app is running in development (npm start), OR
//   • the signed-in user's email is in the allowlist below.
//
// To change the rollout, edit this file in one place:
//   • Make it generally available → `export const canSeeLoanChat = () => true;`
//   • Dev-only                    → drop the allowlist branch.
//   • Different / more people      → edit LOAN_CHAT_ALLOWLIST.
// The tab nav entry AND the route gate both call canSeeLoanChat(), so flipping
// this hides it everywhere at once.
export const LOAN_CHAT_ALLOWLIST = [
  "dev2@arrowservicing.com",
  "dev1@arrowservicing.com",
];

const ALLOWED = new Set(LOAN_CHAT_ALLOWLIST.map((e) => e.toLowerCase()));

const isDev = process.env.NODE_ENV === "development";

export const canSeeLoanChat = (email) =>
  isDev || ALLOWED.has((email || "").trim().toLowerCase());

export default canSeeLoanChat;
